import RecentSitesDataGrid from './RecentSitesDataGrid';

export default RecentSitesDataGrid;
